import { render, staticRenderFns } from "./WorkDocsSchemeClassTableItem.vue?vue&type=template&id=0e07117c&"
import script from "./WorkDocsSchemeClassTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkDocsSchemeClassTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports